import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

// ICONS
import RequestQuoteRoundedIcon from "@mui/icons-material/RequestQuoteRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";

export default function PaymentOrder() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("generar orden de pago") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Generar Órdenes de Pago"
              subtitle="Generar órdenes de pago por abogado"
              icon={<RequestQuoteRoundedIcon />}
              color="#f59e0b"
              to="/paymentOrder/generate/byLawyer"
            />
          </Grid>
        )}

        {hasPermission("generar orden de pago archivo") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Generar por Archivo"
              subtitle="Generar órdenes de pago por numeros de expediente desde archivo"
              icon={<UploadFileRoundedIcon />}
              color="#8b5cf6"
              to="/paymentOrder/generate/byFile"
            />
          </Grid>
        )}

        {hasPermission("importar orden de pago") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Importar Órdenes de Pago"
              subtitle="Subir los .json del importador local y crear las órdenes nuevas"
              icon={<UploadFileRoundedIcon />}
              color="#16a34a"
              to="/paymentOrder/import"
            />
          </Grid>
        )}

        {hasPermission("ver orden de pago") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver Órdenes de Pago"
              subtitle="Ver órdenes de pago generadas"
              icon={<ListAltRoundedIcon />}
              color="#2563eb"
              to="/paymentOrder/manager"
            />
          </Grid>
        )}

        {hasPermission("exportar reporte orden de pago") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reportes"
              subtitle="Descargar órdenes en TXT/Excel y generar el Reporte de Retenciones"
              icon={<AssessmentRoundedIcon />}
              color="#10b981"
              to="/paymentOrder/report/menu"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
